import {HSLA} from '@packages/systems/core/utils/ColorUtils';

export const hslaToCssString = (color: HSLA | undefined): string => {
  if (!color) return '#fff';
  if (typeof color === 'string') return color;

  const {h: hue, s, l, a} = color;
  const saturation = (s * 100).toFixed(2);
  const lightness = (l * 100).toFixed(2);
  const alpha = a.toFixed(2);

  return `hsla(${hue}, ${saturation}%, ${lightness}%, ${alpha})`;
};
